/**
 * @generated SignedSource<<affe928130c8e417a3551ffa77569750>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhasesDropdown_phases$data = ReadonlyArray<{
  readonly node: {
    readonly name: string | null;
    readonly id: string;
  } | null;
  readonly " $fragmentType": "PhasesDropdown_phases";
}>;
export type PhasesDropdown_phases$key = ReadonlyArray<{
  readonly " $data"?: PhasesDropdown_phases$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhasesDropdown_phases">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PhasesDropdown_phases",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhaseType",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhaseTypeEdge",
  "abstractKey": null
};

(node as any).hash = "e943662da8e1da46bac775f3bf2a9449";

export default node;
